module.exports = __webpack_public_path__ + "static/media/pdash-chart-status.baad86be.svg";